export const environment = {
  production: true,
  hmr: false,
  debug: false,
  client: 'Mazda-CA',
  hostName: 'insight.mazdadigitaldealer.ca',
  environmentName: 'production',
  appName: 'Mazda-CA Analytics',
  ssoPassword: 'ShiftDigital#123',
  defaultChartColors: ['#737373', '#000', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  applicationInsights: {
    instrumentationKey: 'e5c2be22-b6fe-4513-a23b-575a53d8a985'
  },
  defaultLocale: 'en',
  availableLocales: ['en', 'fr-CA'],
  timeZone: 'Eastern Standard Time',
  numberOfMonthsToShowDefault: 13,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1, 4],
  closeRateLookbackMonths: 3,
  baseApiUri: 'https://mazdaca-analytics-api-prod.azurewebsites.net/api',
  authUri: 'https://mazdaca-analytics-api-prod.azurewebsites.net/token',
  baseV5ApiUri: 'https://mazda-ca-analytics-apiv5-prod.azurewebsites.net/api',
  retailerToolsBaseUri: '',
  retailerToolsIncludeAuth: false,
  mysteryShopBaseUri: '',
  favIconPath: '/assets/icons/clients/mazda-ca/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: false,
  useV5WebsiteOverview: false,
  v5Reports: ['ServiceSchedulerOverview']
};
